import React from 'react';
import {
	RES_GET_NOTES,
	REQ_GET_NOTES,
	REQ_REMOVE_NOTE,
	RES_REMOVE_NOTE,
	REMOVE_NOTE_ERROR,
	GET_NOTES_ERROR,
	REQ_SAVE_NOTE,
	RES_SAVE_NOTE,
	SAVE_NOTE_ERROR,
	NEW_NOTE,
	SET_ANNOTATION_STATUS,
	COMPONENT_CLICKED,
	SET_CURRENT_COMPONENT_TARGET,
	REMOVE_MOUSEEVENT_LISTENER,
	ADD_MOUSEEVENT_LISTENER
} from '../actions';

function reducer(state = { notes: [], isFetching: false }, action) {
	switch (action.type) {
		case REQ_GET_NOTES:
			return {
				...state,
				isFetching: true
			};
		case RES_GET_NOTES:
			return {
				...state,
				notes: action.notes,
				author: action.author,
				isFetching: false
			};
		case GET_NOTES_ERROR:
			return {
				...state,
				isFetching: false
			};
		case REQ_REMOVE_NOTE:
			return {
				...state,
				notes: state.notes.map(note => note.note_id === action.note_id ? { ...note, isRemoving: true } : note)
			};
		case RES_REMOVE_NOTE:
			return {
				...state,
				notes: state.notes.filter(note => note.note_id !== action.note_id)
			};
		case REMOVE_NOTE_ERROR:
			return {
				...state,
				notes: state.notes.map(note => note.note_id === action.note_id ? { ...note, isRemoving: false } : note)
			};
		case REQ_SAVE_NOTE:
			return {
				...state,
				isSaving: true
			};
		case RES_SAVE_NOTE:
			return {
				...state,
				isSaving: false,
				annotationStatus: 'inactive'
			};
		case SAVE_NOTE_ERROR:
			return {
				...state,
				isSaving: false
			};
		case NEW_NOTE:
			return {
				...state,
				notes: [
					...state.notes,
					action.note
				]
			};
		case SET_ANNOTATION_STATUS:
			return {
				...state,
				annotationStatus: action.annotationStatus
			};
		case COMPONENT_CLICKED:
			return {
				...state,
				mousePosition: {
					left: action.e.pageX,
					top: action.e.pageY
				}
			};
		case REMOVE_MOUSEEVENT_LISTENER:
			return {
				...state,
				eventListeners: {
					...state.eventListeners,
					[action.eventtype]: null
				}
			};
			break;
		case ADD_MOUSEEVENT_LISTENER:
			return {
				...state,
				eventListeners: {
					...state.eventListeners,
					[action.eventtype]: action.proc
				}
			};
			break;
		case SET_CURRENT_COMPONENT_TARGET:
			return {
				...state,
				currentComponentTarget: action.target
			};
		default:
			return state;
	}
}

export default reducer;


// WEBPACK FOOTER //
// ./src/js/reducers/index.js